export class DiscussionMessageModel {
    public Id: number;
    public Deleted: boolean;
    public ChildCount: number;
    public ChildCountByLevel: number;
    public Created: string;
    public ParentCreatedBy: string;
    public CreatedBy_FK: number;
    public CreatedBy_FK_Caption: string;
    public Level: number;
    public Path: string;
    public Text: string;
    public UnRead: boolean;
    public IsPublic: boolean;
    public Status_FK: boolean;
    public Priority_FK: number;
    public Type_FK: number;
    public Responsible_FK: number;
    public Responsible_FK_Caption: string;
    public Document: Array<Object>;

    public EmailSubject: string;
    public EmailTo: string;
    public EmailCC: string;
    public EmailBCC: string;
    public ProjectionActionName: string;

    private _isNew: boolean = false;

    constructor(isNew: boolean = false) {
        this._isNew = isNew;
    }

    public get IsNew() {
        return this._isNew;
    }
}